module.exports = __webpack_public_path__ + "static/media/preview.71eebd49.png";